<template>
  <CustomDeleteDialog
    :dialogTitle="`حذف کلاس گروهی ${
      defaultGroupClass ? defaultGroupClass.name : ''
    }`"
    dialogId="delete-group-class-confirmation-dialog"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendGroupClassDeleteRequest"
  >
    <BCol cols="12">
      <p>
        آیا از حذف کلاس گروهی
        <span class="font-weight-bolder">
          {{ defaultGroupClass ? defaultGroupClass.name : "" }}
        </span>
        اطمینان دارید؟
      </p>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    defaultGroupClass: {
      type: Object,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendGroupClassDeleteRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let deleteGroupClass = new DeleteGroupClass(_this);
        deleteGroupClass.setRequestParam({
          groupClassId: _this.defaultGroupClass.id,
        });
        await deleteGroupClass.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "کلاس گروهی با موفقیت حذف شد.",
              },
            });
            this.$bvModal.hide("delete-group-class-confirmation-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    BCol,
    CustomDeleteDialog,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { DeleteGroupClass } from "@/libs/Api/GroupClass";
import { BCol } from "bootstrap-vue";
</script>
